import { render, staticRenderFns } from "./JpReceRequestAgainDialog.vue?vue&type=template&id=03981ca4&scoped=true"
import script from "./JpReceRequestAgainDialog.vue?vue&type=script&lang=js"
export * from "./JpReceRequestAgainDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03981ca4",
  null
  
)

export default component.exports